import type { TenantAuthConfigPublicDto } from '@avila-roffe/api-clients-admin-bff';
import { useTenantContext } from './TenantContext';

export interface TenantConfig {
  slug: string;
  config: TenantAuthConfigPublicDto;
}

/**
 * Returns the resolved tenant slug and auth config.
 * Safe to call only inside routes that are children of TenantBootstrapProvider
 * (i.e. after status === 'ready' — the provider gates rendering until then).
 */
export function useTenantConfig(): TenantConfig {
  const { slug, config } = useTenantContext();

  if (!slug || !config) {
    throw new Error('useTenantConfig called before tenant bootstrap completed');
  }

  return { slug, config };
}
